import { Element } from '@craftjs/core'
import {
  Button,
  CardGroup,
  Text,
  TextEditor,
  TextMedia,
  // Video,
  WContainer,
  // ZoomImage,
  HeroHome,
  HeroHomeSlide,
  IconsSection,
  IconCard,
  ApplicazioneCard,
  ApplicazioniSection,
  AnchorCard,
  AnchorSection,
  BrandsSection,
  DownloadLink,
  CataloghiBlock,
  CataloghiSection,
  CustomCode,
} from 'react-pagebuilder/components'

import {
  Container,
  Button as ButtonIcon,
  Text as TextIcon,
  WireframeMode as WireframeIcon
  // Image as ImageIcon,
  // Video as VideoIcon,
} from 'react-pagebuilder/pb-components/icons'

// shortcut
const INTRO = <TextEditor block={{ text: 'Intro', noHtml: true }} />
const TITOLO = <TextEditor block={{ text: 'Titolo', noHtml: true }} />
const CTA_LABEL = <TextEditor block={{ text: 'Cta label', noHtml: true }} />
const DESCRIZIONE = <TextEditor block={{ text: 'Lorem ipsum dolor sit amet' }} />

export const TEXT = (
  <Element is={Text}>
    <TextEditor
      block={{
        text: '<p>Hello world!</p>',
        className: 'text__content',
      }}
    />
  </Element>
)

export const BUTTON = (
  <Element is={Button}>
    <TextEditor
      block={{
        text: 'Click me',
        noHtml: true,
      }}
    />
  </Element>
)

export const WCONTAINER = <Element canvas is={WContainer}></Element>
export const CUSTOM_CODE = <CustomCode />

// export const ZOOM_IMAGE = <ZoomImage block={{ src: 'https://placehold.co/800x600/png' }} />

// export const VIDEO = <Video />

export const TEXT_MEDIA = (
  <Element is={TextMedia}>
    {TITOLO}
    {INTRO}
    {DESCRIZIONE}
    <Element is={CardGroup} canvas>
      {BUTTON}
    </Element>
  </Element>
)

export const HERO_HOME_SLIDE = (
  <Element is={HeroHomeSlide}>
    {TITOLO}
    {CTA_LABEL}
  </Element>
)

export const HERO_HOME = (
  <Element is={HeroHome}>
    <Element is={CardGroup} canvas type="heroHome">
      {HERO_HOME_SLIDE}
    </Element>
  </Element>
)

export const APPLICAZIONE_CARD = (
  <Element is={ApplicazioneCard}>
    {TITOLO}
    {DESCRIZIONE}
  </Element>
)

export const APPLICAZIONI_SECTION = (
  <Element is={ApplicazioniSection}>
    {TITOLO}
    {DESCRIZIONE}
    <Element is={CardGroup} canvas type="applicazioniSection">
      {APPLICAZIONE_CARD}
      {APPLICAZIONE_CARD}
    </Element>
  </Element>
)

export const ICON_CARD = <Element is={IconCard}>{TITOLO}</Element>

export const ICONS_SECTION = (
  <Element is={IconsSection}>
    {TITOLO}
    {DESCRIZIONE}
    <Element is={CardGroup} canvas type="iconsSection">
      {ICON_CARD}
      {ICON_CARD}
    </Element>
  </Element>
)

export const ANCHOR_CARD = (
  <Element is={AnchorCard}>
    {TITOLO}
    <TextEditor block={{ text: 'Descrizione', noHtml: true }} />{' '}
    {/* qui è senza html - viene usato nelle tecnologie come sottotitolo */}
  </Element>
)

export const ANCHOR_SECTION = (
  <Element is={AnchorSection}>
    {TITOLO}
    {DESCRIZIONE}
    <Element is={CardGroup} canvas type="anchorSection">
      {ANCHOR_CARD}
      {ANCHOR_CARD}
    </Element>
  </Element>
)

export const BRANDS_SECTION = (
  <Element is={BrandsSection}>
    {TITOLO}
    {DESCRIZIONE}
  </Element>
)

export const DOWNLOAD_LINK = <Element is={DownloadLink}>{TITOLO}</Element>

export const CATALOGHI_BLOCK = (
  <Element is={CataloghiBlock}>
    {TITOLO}
    <Element is={CardGroup} canvas type="cataloghiBlock">
      {DOWNLOAD_LINK}
    </Element>
  </Element>
)

export const CATALOGHI_SECTION = (
  <Element is={CataloghiSection}>
    {TITOLO}
    {DESCRIZIONE}
    <Element is={CardGroup} canvas type="cataloghiSection">
      {CATALOGHI_BLOCK}
      {CATALOGHI_BLOCK}
    </Element>
  </Element>
)

// possibilità di inserire icona per il block
export const conf = [
  {
    title: 'Layout',
    blocks: {
      wcontainer: {
        name: 'Container',
        icon: <Container />,
        block: WCONTAINER,
      },
    },
  },
  {
    title: 'Basic',
    blocks: {
      text: {
        name: 'Testo',
        icon: <TextIcon />,
        block: TEXT,
      },
      // image: {
      //   name: 'Immagine',
      //   icon: <ImageIcon />,
      //   block: ZOOM_IMAGE,
      // },
      // video: {
      //   name: 'Video',
      //   icon: <VideoIcon />,
      //   block: VIDEO,
      // },
      button: {
        name: 'Button',
        icon: <ButtonIcon />,
        block: BUTTON,
      },
      custom_code: {
        name: 'Custom Code',
        icon: <WireframeIcon />,
        block: CUSTOM_CODE,
      },
    },
  },
  {
    title: 'Box',
    blocks: {
      anchorSection: {
        name: 'Anchor section',
        image: 'anchorSection.png',
        block: ANCHOR_SECTION,
      },
      applicazioniSection: {
        name: 'Applicazioni section',
        image: 'applicazioniSection.png',
        block: APPLICAZIONI_SECTION,
      },
      brandsSection: {
        name: 'Brands section',
        image: 'brandsSection.png',
        block: BRANDS_SECTION,
      },
      cataloghiSection: {
        name: 'Cataloghi section',
        image: 'cataloghiSection.png',
        block: CATALOGHI_SECTION,
      },
      iconSection: {
        name: 'Icons section',
        image: 'iconsSection.png',
        block: ICONS_SECTION,
      },
      textMedia: {
        name: 'Text Media',
        image: 'textMedia.png',
        block: TEXT_MEDIA,
      },
    },
  },
  {
    title: 'Card',
    blocks: {
      anchorCard: {
        name: 'Anchor Card',
        image: 'anchorCard.png',
        block: ANCHOR_CARD,
      },
      applicazioneCard: {
        name: 'Applicazione Card',
        image: 'applicazioneCard.png',
        block: APPLICAZIONE_CARD,
      },
      cataloghiBlock: {
        name: 'Cataloghi block',
        image: 'cataloghiBlock.png',
        block: CATALOGHI_BLOCK,
      },
      downloadLink: {
        name: 'Download link',
        image: 'downloadLink.png',
        block: DOWNLOAD_LINK,
      },
      iconCard: {
        name: 'Icon Card',
        image: 'iconCard.png',
        block: ICON_CARD,
      },
    },
  },
  {
    title: 'Slider',
    blocks: {
      heroHome: {
        name: 'Hero Home',
        image: 'heroHome.png',
        block: HERO_HOME,
      },
    },
  },
  {
    title: 'Slide',
    blocks: {
      heroHomeSlide: {
        name: 'Hero Home Slide',
        image: 'heroHomeSlide.png',
        block: HERO_HOME_SLIDE,
      },
    },
  },
]
